module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result22-d0665620dc1b9bcb5467e92d05e64109.png";